import { Component, OnInit } from '@angular/core';
import CONFIG from 'src/app/app.config';

@Component({
  selector: 'app-not-found',
  templateUrl: './not-found.component.html',
  styleUrls: ['./not-found.component.scss'],
   host: {
    'class':  'container cc-component-container cc-wrapper-container pt-6 mt-3', 
    'id': 'auth-component-backdrop'
  },
})
export class NotFoundComponent implements OnInit {
  urlPaths = CONFIG.APPLICATION.URL;

  constructor() { }

  ngOnInit(): void {
  }

}
